import { useShellUtilitiesStore, } from '@office-start/shell-utilities-store';
import { useEffect, useRef } from 'react';
var selector = function (x) { return x.loaded; };
export var useAfterShellPlusLoaded = function (callback) {
    var loaded = useShellUtilitiesStore(selector);
    var canRunCallback = useRef(true);
    useEffect(function () {
        if (loaded && canRunCallback.current) {
            canRunCallback.current = false;
            callback();
        }
    }, [callback, loaded]);
    return function () {
        canRunCallback.current = false;
    };
};
//# sourceMappingURL=useAfterShellPlusLoaded.js.map